<script lang="ts">
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import Button from "./ui/button/button.svelte";

  let {
    positionDialog = $bindable(),
    onclick,
  }: { positionDialog: boolean; onclick: () => void } = $props();

  function handleclick() {
    onclick();
    positionDialog = false;
  }
</script>

<Dialog.Root bind:open={positionDialog}>
  <Dialog.Content
    class="border-2 border-black rounded-sm shadow-[3px_3px_0px_0px] shadow-foreground"
  >
    <Dialog.Header>
      <Dialog.Title class="text-center text-2xl">
        Oszd meg a pozíciód!
      </Dialog.Title>
      <img alt="beeco-logo" class="mx-auto h-40" src="/assets/beeco-bee.svg" />
      <Dialog.Description class="text-center">
        Szükségünk van a pozíciódra, hogy meg tudjuk mutdjuk mutatni a pozíciód
        és távolságot tudjunk számolni te és a térkép pontok között.
      </Dialog.Description>
    </Dialog.Header>
    <Button
      onclick={handleclick}
      class="w-48 mx-auto bg-primary hover:bg-primary/80"
    >
      Megosztom!
    </Button>
  </Dialog.Content>
</Dialog.Root>
